import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import { useNavigate } from "react-router-dom";
import "./Capabilities.css"; // Ensure this matches your updated CSS file
import itManagementImage from "../../images/it-management.jpg"; // Update with the correct image path

const ITManagement = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="cap-container">
        <h1>IT Management Services</h1>

        <div className="cap-section">
          <div className="text-content">
          <h2>Optimizing IT Systems for Healthcare Efficiency</h2>
          <p>
            In today’s digital era, a well-managed IT infrastructure is critical for healthcare organizations to operate efficiently, securely, and in compliance with regulatory standards.
            At S&S Healthcare Consulting, we provide comprehensive IT management services tailored specifically for medical practices, hospitals, and healthcare organizations.
          </p>
          <p>
            Our team ensures that your technology, systems, and networks run smoothly, allowing you to focus on patient care and business growth without worrying about IT-related issues.
          </p>
          <p>
            Our proactive IT management solutions help you improve operational efficiency, minimize downtime, enhance cybersecurity, and ensure regulatory compliance with HIPAA, HITECH, and other healthcare IT standards.
          </p>

            <button className="cap-button" onClick={() => navigate("/learn-more/it-management")}>Learn More</button>
          </div>

          {/* Image Section */}
          <div className="image-container">
            <img src={itManagementImage} alt="IT Management" />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ITManagement;
